import Tables from "./Tables";
import BoardCv from "./BoardCv";
import cvData from "../../data/transparency/board_cv.json";
import { useTranslation } from "react-i18next";
import Intro from "./Intro";
import SEO from "../common/SEO";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIdCard } from "@fortawesome/free-solid-svg-icons";

const Transparency = ({ formatDate, renderBody }) => {
  const { t, i18n } = useTranslation();
  const isEnglish = (i18n.language || "it").startsWith("en");
  const title = isEnglish ? "Transparency & Governance" : "Trasparenza & Organo Direttivo";
  const desc = isEnglish
    ? "Institutional transparency, board CVs, and public funding received by Nuova Orchestra da Camera Ferruccio Busoni (L. 124/2017)."
    : "Trasparenza amministrativa, curriculum dei membri del Consiglio Direttivo e contributi pubblici ricevuti dall'Associazione Nuova Orchestra da Camera Ferruccio Busoni (L. 124/2017).";

  return (
    <>
      <SEO title={title} description={desc} />
      <section className="section subpage-section">
        <div className="container subpage-container">
          {/* Header */}
          <div className="text-center mb-5">
            <h2 className="subpage-title">{title}</h2>
            <p className="text-muted max-w-700 mx-auto mt-2">
              {isEnglish
                ? "Information published in compliance with Law no. 124 of August 4, 2017 regarding transparency and public funding."
                : "Adempimento degli obblighi di trasparenza e pubblicità ai sensi della Legge 4 agosto 2017, n. 124 (art. 1, commi 125-129)."}
            </p>
          </div>

          <Intro t={t} />

          {/* Curriculum Board */}
          <div className="board-cv-section mb-5">
            <div className="d-flex align-items-center mb-3">
              <FontAwesomeIcon icon={faIdCard} className="text-warning fs-4 me-3" />
              <h4 className="section-subheading mb-0 text-capitalize">
                {t("transparency.curriculum_board")}
              </h4>
            </div>
            <p className="text-muted small mb-4">{t("transparency.intro_4")}</p>
            {cvData.map((member) => (
              <BoardCv key={member.id} member={member} renderBody={renderBody} />
            ))}
          </div>

          <Tables formatDate={formatDate} />
        </div>
      </section>
    </>
  );
};

export default Transparency;
